<span class="downloading-message" *ngIf="status === propertyStatus.downloading">
    {{downloadingMessage}}
</span>

<div class="progress-bar" *ngIf="status === propertyStatus.downloading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="downloading-message" *ngIf="status === propertyStatus.error">
    <mat-icon svgIcon="warning_icon" class="small-icon" ></mat-icon>
    <span>{{errorMessage}}</span>
</div>


